import { workspaceRouteDescriptorForHref } from './workspace-route-descriptors';
import { primaryWorkspaceRouteMetadata } from './workspace-route-metadata';

const inFlight = new Map<string, Promise<unknown>>();

export const workspaceRoutePreloadTarget = (href: string) =>
  workspaceRouteDescriptorForHref(href)?.href ?? null;

export const preloadWorkspaceRoute = (href: string) => {
  const target = workspaceRoutePreloadTarget(href);
  if (!target) return Promise.resolve();
  const existing = inFlight.get(target);
  if (existing) return existing;
  const descriptor = workspaceRouteDescriptorForHref(target);
  if (!descriptor) return Promise.resolve();
  const operation = descriptor.loadModule();
  inFlight.set(target, operation);
  return operation;
};

export const idlePrefetchRoutes = primaryWorkspaceRouteMetadata
  .filter((descriptor) => descriptor.idleCode)
  .map((descriptor) => descriptor.href);
